import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/cs';
import 'dayjs/locale/de';
import 'dayjs/locale/sk';
import 'dayjs/locale/hu';
import 'dayjs/locale/it';
import 'dayjs/locale/ro';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);

const SUPPORTED_DAYJS_LOCALES = new Set(['cs', 'de', 'en', 'hu', 'it', 'ro', 'sk']);

export function toDayjsLocale(locale: string): string {
  const normalized = locale.toLowerCase();
  if (SUPPORTED_DAYJS_LOCALES.has(normalized)) {
    return normalized;
  }

  const twoLetter = normalized.split('-')[0] ?? normalized;
  if (SUPPORTED_DAYJS_LOCALES.has(twoLetter)) {
    return twoLetter;
  }

  return 'en';
}

export { dayjs };
